module.exports = __webpack_public_path__ + "img/news3-1.b970ee60.png";